/**
 * @file コンポーネント：フル動画ページ決済情報ポップアップ DOM管理
 */

// ライブラリ読み込み
import React from "react";
import ReactDOMServer from "react-dom/server";

// コンポーネント読み込み
import { Popup } from "~/src/components/projects/Popup";
import { Price } from "~/src/components/uiparts/Price";

// 関数読み込み
import { fnReplaceLocalizedText } from "~/src/functions/common";

// スタイル読み込み
import {
    StyledPopupContainer,
    StyledPopupContainerBody,
    StyledPopupContainerBodyDescription,
    StyledPopupContainerBodyDescriptionAnchor,
    StyledPopupContainerBodyDescriptionAnchorIcon,
    StyledPopupContainerBodyDescriptionAnchorText,
    StyledPopupContainerBodyPrice,
    StyledPopupContainerBodyThumbnail,
    StyledPopupContainerBodyThumbnailImage,
    StyledPopupContainerBodyTitle,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledPopupContainer>
            {props.isOpenPopupPayment === true && (
                <Popup
                    buttonlist={[
                        {
                            buttonType: "submit",
                            onClick: (e) => props.fnOnClickPayment(e),
                            text: localized["Label.GoToPayment"],
                        },
                    ]}
                    content={[
                        <StyledPopupContainerBody
                            key="popup"
                            ref={props.refForm}
                        >
                            {/* 症例タイトル */}
                            <StyledPopupContainerBodyTitle>
                                {props.title}
                            </StyledPopupContainerBodyTitle>
                            {/* 症例サムネイル */}
                            <StyledPopupContainerBodyThumbnail>
                                <StyledPopupContainerBodyThumbnailImage
                                    alt={props.title}
                                    src={props.thumbnail}
                                />
                            </StyledPopupContainerBodyThumbnail>
                            {/* 価格 */}
                            <StyledPopupContainerBodyPrice>
                                {props.price !== null && (
                                    <Price price={props.price} />
                                )}
                            </StyledPopupContainerBodyPrice>
                            {/* 決済説明 */}
                            <StyledPopupContainerBodyDescription
                                dangerouslySetInnerHTML={{
                                    __html: fnReplaceLocalizedText(
                                        localized["Label.PaymentDescription"],
                                        [
                                            // 利用規約リンク
                                            ReactDOMServer.renderToString(
                                                <StyledPopupContainerBodyDescriptionAnchor
                                                    href="#"
                                                    id="js-anchor-terms"
                                                >
                                                    <StyledPopupContainerBodyDescriptionAnchorText>
                                                        {
                                                            localized[
                                                                "Label.Terms"
                                                            ]
                                                        }
                                                    </StyledPopupContainerBodyDescriptionAnchorText>
                                                    <StyledPopupContainerBodyDescriptionAnchorIcon>
                                                        <i className="fas fa-clone"></i>
                                                    </StyledPopupContainerBodyDescriptionAnchorIcon>
                                                </StyledPopupContainerBodyDescriptionAnchor>
                                            ),
                                            // 推奨環境リンク
                                            ReactDOMServer.renderToString(
                                                <StyledPopupContainerBodyDescriptionAnchor href="/accessibility">
                                                    <StyledPopupContainerBodyDescriptionAnchorText>
                                                        {
                                                            localized[
                                                                "Label.Accessibility"
                                                            ]
                                                        }
                                                    </StyledPopupContainerBodyDescriptionAnchorText>
                                                </StyledPopupContainerBodyDescriptionAnchor>
                                            ),
                                            // 特商法リンク
                                            ReactDOMServer.renderToString(
                                                <StyledPopupContainerBodyDescriptionAnchor
                                                    href="https://www.opexpark.co.jp/specified-commercial/"
                                                    target="_blank"
                                                >
                                                    <StyledPopupContainerBodyDescriptionAnchorText>
                                                        {
                                                            localized[
                                                                "Label.SpecifiedCommercialTransactionAct"
                                                            ]
                                                        }
                                                    </StyledPopupContainerBodyDescriptionAnchorText>
                                                    <StyledPopupContainerBodyDescriptionAnchorIcon>
                                                        <i className="fas fa-external-link-alt"></i>
                                                    </StyledPopupContainerBodyDescriptionAnchorIcon>
                                                </StyledPopupContainerBodyDescriptionAnchor>
                                            ),
                                        ]
                                    ),
                                }}
                            />
                        </StyledPopupContainerBody>,
                    ]}
                    headline={localized["Label.PaymentMenu"]}
                    isHighlight={props.isHighlightPopupPayment}
                    isOpen={props.isOpenPopupPayment}
                    position="bottom"
                    setIsOpen={props.setIsOpenPopupPayment}
                />
            )}
        </StyledPopupContainer>
    );
};
